var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from "react";
import { useWebgate } from "@xvia/webgate-connect";
import { apiClient } from "../api/apiClient";
import { WebgateAuthContext } from "./useWebgateAuth";
export var WebgateAuthProvider = function (_a) {
    var children = _a.children;
    var _b = useWebgate(), accessToken = _b.accessToken, userInfo = _b.userInfo, initialized = _b.initialized, portalConnect = _b.portalConnect;
    var _c = useState(null), citizenProfile = _c[0], setCitizenProfile = _c[1];
    var _d = useState(null), citizenId = _d[0], setCitizenId = _d[1];
    var _e = useState(false), loadingProfile = _e[0], setLoadingProfile = _e[1];
    useEffect(function () {
        if (!accessToken)
            return;
        var interceptor = apiClient.interceptors.request.use(function (config) {
            config.headers.set("Authorization", "Bearer ".concat(accessToken));
            return config;
        });
        return function () {
            apiClient.interceptors.request.eject(interceptor);
        };
    }, [accessToken]);
    useEffect(function () {
        if (userInfo) {
            // eslint-disable-next-line no-console
            console.log("[DEBUG] useWebgate userInfo:", userInfo);
        }
    }, [userInfo]);
    useEffect(function () {
        if (!accessToken || !initialized) {
            setCitizenProfile(null);
            setCitizenId(null);
            return;
        }
        var mounted = true;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, user, _a;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 2, 3, 4]);
                        setLoadingProfile(true);
                        return [4 /*yield*/, apiClient.get("/auth/profile")];
                    case 1:
                        res = _f.sent();
                        user = ((_d = (_c = (_b = res.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.user) !== null && _d !== void 0 ? _d : null);
                        if (mounted) {
                            setCitizenProfile(user);
                            setCitizenId((_e = user === null || user === void 0 ? void 0 : user.id) !== null && _e !== void 0 ? _e : null);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        _a = _f.sent();
                        if (mounted) {
                            setCitizenProfile(null);
                            setCitizenId(null);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        if (mounted)
                            setLoadingProfile(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            mounted = false;
        };
    }, [accessToken, initialized]);
    // Estáveis enquanto `portalConnect` não muda. Sem isso, cada render gera uma
    // nova função `login`, o que faz o efeito de redirecionamento do ProtectedRoute
    // (que tem `login` nas deps) re-executar a cada render.
    var hasOAuthCallbackHash = function () {
        if (typeof window === "undefined")
            return false;
        var hash = window.location.hash.replace(/^#/, "");
        if (!hash)
            return false;
        var params = new URLSearchParams(hash);
        return (params.has("code") ||
            params.has("state") ||
            params.has("session_state") ||
            params.has("iss"));
    };
    var clearOAuthCallbackHash = function () {
        if (typeof window === "undefined")
            return;
        if (!hasOAuthCallbackHash())
            return;
        var cleanUrl = "".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search);
        window.history.replaceState({}, document.title, cleanUrl);
    };
    var login = useCallback(function () {
        clearOAuthCallbackHash();
        portalConnect === null || portalConnect === void 0 ? void 0 : portalConnect.login();
    }, [portalConnect]);
    var logout = useCallback(function () { return portalConnect === null || portalConnect === void 0 ? void 0 : portalConnect.logout(); }, [portalConnect]);
    return (_jsx(WebgateAuthContext.Provider, __assign({ value: {
            accessToken: accessToken,
            userInfo: userInfo,
            initialized: !!initialized,
            citizenProfile: citizenProfile,
            citizenId: citizenId,
            loadingProfile: loadingProfile,
            login: login,
            logout: logout,
        } }, { children: children })));
};
